import React from 'react';
import { AppLayout } from '../../app/appLayout.js';

const HomeScreen = () => {
    return (
        <AppLayout>
            <h2>Welcome to WR Budget</h2>
        </AppLayout>
    );
};

export { HomeScreen };
